import React, { useEffect, useState } from 'react';
import { Sponsor } from '../types';
import { useSponsors } from '../store/sponsors';

const ROTATE_MS = 8000;

// Vises i samme kompakte plass som delings-boksen ("Dere deler i stedet for
// å kjøpe nytt") — kun når det faktisk finnes minst én aktiv sponsor akkurat nå.
// Har sponsoren et bilde, fyller det hele boksen med navn/tekst i hvitt over en
// gradient. Har den ikke (f.eks. en ren tekst-egenreklame), vises et enklere
// kort med mørk tekst i stedet. Lenke er valgfri — uten den blir kortet ikke klikkbart.
export const SponsorBanner: React.FC<{ sponsors: Sponsor[] }> = ({ sponsors }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (sponsors.length < 2) return;
    const timer = setInterval(() => {
      setIndex(i => (i + 1) % sponsors.length);
    }, ROTATE_MS);
    return () => clearInterval(timer);
  }, [sponsors.length]);

  if (sponsors.length === 0) return null;
  const sponsor = sponsors[index % sponsors.length];
  const Wrapper: any = sponsor.link_url ? 'a' : 'div';
  const wrapperProps = sponsor.link_url
    ? { href: sponsor.link_url, target: '_blank', rel: 'noopener noreferrer', onClick: () => useSponsors.getState().logSponsorClick(sponsor.id) }
    : {};

  const rotationDots = sponsors.length > 1 && (
    <span style={{ position: 'absolute', bottom: 6, right: 8, display: 'flex', gap: 3 }}>
      {sponsors.map((s, i) => (
        <span key={s.id} style={{
          width: 4, height: 4, borderRadius: '50%',
          background: i === index % sponsors.length
            ? (sponsor.image_url ? '#fff' : 'var(--text3)')
            : (sponsor.image_url ? 'rgba(255,255,255,0.5)' : 'var(--border-strong)'),
        }} />
      ))}
    </span>
  );

  if (sponsor.image_url) {
    return (
      <Wrapper
        key={sponsor.id}
        {...wrapperProps}
        style={{
          flex: 1, minWidth: 0, height: '100%', boxSizing: 'border-box', position: 'relative', display: 'block',
          borderRadius: 'var(--radius-sm)', overflow: 'hidden', border: '1px solid var(--border-strong)',
        }}
      >
        <img
          src={sponsor.image_url}
          alt={sponsor.company_name}
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
        <div style={{
          position: 'absolute', left: 0, right: 0, bottom: 0,
          background: 'linear-gradient(to top, rgba(0,0,0,0.82), rgba(0,0,0,0))',
          padding: '42px 10px 9px',
        }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: '#fff', lineHeight: 1.2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {sponsor.company_name}
          </div>
          {sponsor.tagline && (
            <div style={{
              fontSize: 12.5, color: 'rgba(255,255,255,0.9)', lineHeight: 1.3, marginTop: 2,
              display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical' as any, overflow: 'hidden',
            }}>
              {sponsor.tagline}
            </div>
          )}
        </div>
        <span style={{
          position: 'absolute', top: 6, right: 6,
          background: 'rgba(0,0,0,0.55)', color: '#fff',
          fontSize: 9.5, fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase',
          padding: '2px 7px', borderRadius: 30,
        }}>
          Annonse
        </span>
        {rotationDots}
      </Wrapper>
    );
  }

  return (
    <Wrapper
      key={sponsor.id}
      {...wrapperProps}
      style={{
        flex: 1, minWidth: 0, height: '100%', boxSizing: 'border-box', position: 'relative', overflow: 'hidden',
        display: 'flex', flexDirection: 'column', justifyContent: 'center',
        borderRadius: 'var(--radius-sm)', border: '1px solid var(--border-strong)',
        background: 'var(--surface)', padding: '12px 14px', textDecoration: 'none',
      }}
    >
      <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--text)', lineHeight: 1.25, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {sponsor.company_name}
      </div>
      {sponsor.tagline && (
        <div style={{
          fontSize: 12.5, color: 'var(--text2)', lineHeight: 1.35, marginTop: 2,
          display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical' as any, overflow: 'hidden',
        }}>
          {sponsor.tagline}
        </div>
      )}
      <span style={{
        position: 'absolute', top: 6, right: 6,
        background: 'var(--bg)', color: 'var(--text3)', border: '1px solid var(--border)',
        fontSize: 9.5, fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase',
        padding: '2px 7px', borderRadius: 30,
      }}>
        Annonse
      </span>
      {rotationDots}
    </Wrapper>
  );
};
